import { render, staticRenderFns } from "./MinhasCompras.vue?vue&type=template&id=4288609c"
import script from "./MinhasCompras.vue?vue&type=script&lang=js"
export * from "./MinhasCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports